import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { gutil } from '../../gutil';
import { faCheckCircle, faExclamationCircle, faTimesCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';

declare var $:any;

@Component({
  selector: 'app-upload-docs-and-refs',
  templateUrl: './upload-docs-and-refs.component.html',
  styleUrls: ['./upload-docs-and-refs.component.scss']
})
export class UploadDocsAndRefsComponent implements OnInit {

  public faCheckCircle = faCheckCircle;
  public faExclamationCircle = faExclamationCircle;
  public faTimesCircle = faTimesCircle;
  public faTimes = faTimes;
  public user:any;
  public ref1PopupAdd = {user_id:"",name:"",email:"",phone:"",address:"" , city:"", state:"", zip:"",status:0};
  public ref2PopupAdd = {user_id:"",name:"",email:"",phone:"",address:"" , city:"", state:"", zip:"",status:0};
  public ref_data: any;
  public uploadDoc = {status: 0, user_id: "",property_id: 0, room_id: 0,docNo:"adhar",docName:"", dockey: "", comments: ""};
  public docTypeSel: Array<any>;
  public docInfo:any;
  public docAdhar:Array<any>;
  public doc_data:Array<any>;
  public isRefsDisabled:boolean = true;
  public isDocDisabled:boolean = false;
  public email_re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public phone_re = /\+?\d[\d -]{8,12}\d/;
  public ref_msg:boolean;
  public ref_msg_str:string;
  public docUploadPass : boolean;
  public docUploadFail : boolean;
  public docUploadStatMsg : string;

  constructor(private http:HttpClient, private router: Router) {

    this.docTypeSel = gutil.docTypesSel;
    this.docAdhar = gutil.docAdhar;
   }

  ngOnInit(): void {
    this.user = gutil.user;
    this.fetchRefData();
    this.fetchDocumentInfo();
    this.docUploadPass= false;
    this.docUploadFail= false;
    this.docUploadStatMsg = "";
  }
  public changeRef1Name(value:any) {
    this.ref1PopupAdd.name = value;
  }
  public changeRef1Email(value:any) {
    this.ref1PopupAdd.email = value;
  }
  public changeRef1Phone(value:any) {
    this.ref1PopupAdd.phone = value;
  }
  public changeRef1Address(value:any) {
    this.ref1PopupAdd.address = value;
  }
  public changeRef1City(value:any) {
    this.ref1PopupAdd.city = value;
  }
  public changeRef1State(value:any) {
    this.ref1PopupAdd.state = value;
  }
  public changeRef1Zip(value:any) {
    this.ref1PopupAdd.zip = value;
  }

//Data fields for Reference 2 

  public changeRef2Name(value:any) {
    this.ref2PopupAdd.name = value;
  }
  public changeRef2Email(value:any) {
    this.ref2PopupAdd.email = value;
  } 
  public changeRef2Phone(value:any) {
    this.ref2PopupAdd.phone = value;
  }
  public changeRef2Address(value:any) {
    this.ref2PopupAdd.address = value;
  }
  public changeRef2City(value:any) {
    this.ref2PopupAdd.city = value;
  }
  public changeRef2State(value:any) {
    this.ref2PopupAdd.state = value;
  }
  public changeRef2Zip(value:any) {
    this.ref2PopupAdd.zip = value;
  }
  public submitRef1() {
    if(this.ref1PopupAdd.name != "" && this.ref1PopupAdd.email != "" && this.ref1PopupAdd.phone != "" && this.ref1PopupAdd.address != "" && this.ref1PopupAdd.city != "" && this.ref1PopupAdd.state != "" && this.ref1PopupAdd.zip !="" ) {
        
        if(this.email_re.test(this.ref1PopupAdd.email)) {
          if(this.phone_re.test(this.ref1PopupAdd.phone)) {
            
              let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
              let options =  {headers: headers };
              let params = new URLSearchParams();
              this.ref1PopupAdd.user_id = this.user.id;
              
              for(let x in this.ref1PopupAdd){
                  params.append(x, this.ref1PopupAdd[x]);
              }
              let paramsString = params.toString();
              this.http.post(gutil.devapiUrl + '/api/v1/references/add/' + this.user.id + '?api_token=' + this.user.api_token, paramsString, options)
                  .subscribe((data:any) => {
                    console.log("Form 1 submit successful!");
                    this.ref_msg = true;
                    this.ref_msg_str = "Reference 1 added successfully!";
                    setTimeout(() => {
                      $('#ref1Modal').modal('hide');
                      $('#ref2Modal').modal('show');
                      this.ref_msg = false;
                      this.closeNotification();
                    },2000)
                  })
          }
          else {
              this.ref_msg = true;
              this.ref_msg_str = "Invalid Phone Number";
              this.closeNotification();
          }
        }
        else {
          this.ref_msg = true;
          this.ref_msg_str = "Invalid Email";
          this.closeNotification();
        }
    }
    else {
      this.ref_msg = true;
      this.ref_msg_str = "All fields mandatory!";
      this.closeNotification();
    }
    
  }
  public submitRef2() {
    if(this.ref2PopupAdd.name != "" && this.ref2PopupAdd.email != "" && this.ref2PopupAdd.phone != "" && this.ref2PopupAdd.address !="" && this.ref2PopupAdd.city !="" && this.ref2PopupAdd.state != "" && this.ref2PopupAdd.zip != "") {
      if(this.email_re.test(this.ref2PopupAdd.email)) {
        if(this.phone_re.test(this.ref2PopupAdd.phone)) {
              let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
              let options =  {headers: headers };
              let params = new URLSearchParams();
              this.ref2PopupAdd.user_id = this.user.id;
              
              for(let x in this.ref2PopupAdd){
                  params.append(x, this.ref2PopupAdd[x]);
              }
              let paramsString2 = params.toString();
              console.log(paramsString2);
              this.http.post(gutil.devapiUrl + '/api/v1/references/add/' + this.user.id + '?api_token=' + this.user.api_token, paramsString2, options)
                  .subscribe((data:any) => {
                    this.ref_msg = true;
                    this.ref_msg_str = "Reference 2 added successfully!";
                    
                    this.router.navigateByUrl('/profile/tenant').then(() => {
                      window.location.reload();
                    })
                    
                  })
        }
        else {
          this.ref_msg = true;
          this.ref_msg_str = "Invalid Phone Number";
          this.closeNotification();
        }
      }
      else {
        this.ref_msg = true;
        this.ref_msg_str = "Invalid Email";
        this.closeNotification();
      }
    }
    else {
      this.ref_msg = true;
      this.ref_msg_str = "All Fields Mandatory!";
      this.closeNotification();
    }
    
  }
  public fetchRefData() {
    this.http.get(gutil.devapiUrl + '/api/v1/references/info/user/' + this.user.id +'?api_token=' + this.user.api_token)
      .subscribe((data:any) => {
        this.ref_data = data.obj;
      })
  }
  public closeNotification() {
    setTimeout(() => {
      this.ref_msg = false;
    }, 2000)
  }
///////////////////////////////////////// Document Upload TS ///////////////////////////////////////////

  public fetchDocumentInfo() {
    this.isRefsDisabled = true;
    this.http.get(gutil.devapiUrl +'/api/v1/documents/info/' + this.user.id + '?api_token=' + this.user.api_token)
        .subscribe((data:any) => {
          this.docInfo = data;
          this.doc_data = data.data;
          if(this.doc_data.length >=2) {
            this.isRefsDisabled = false;
            this.isDocDisabled = true;
          }
        })
  }
  public onDocTypeChange(value:any){
    if(this.uploadDoc !== undefined && this.uploadDoc['dockey'] !== undefined && this.uploadDoc['dockey'] == value){
      console.log('do nothing');
    }else{
      this.uploadDoc = {status: 0, user_id: this.user.id,property_id: 0, room_id: 0,docNo:"",docName:"", dockey: value, comments: ""};
      this.uploadDoc[value] = null;
      
    }
  }
  public onDocNumChange(value:any){
    this.uploadDoc['docNo'] = value.target.value;
  }
  public onDocNameChange(value:any){
    
    this.uploadDoc['docName'] = value.target.value;
  }
  public onDocChange(value:any) {
    if(value.target.files[0] !== undefined){
      this.uploadDoc[this.uploadDoc['dockey']] = value.target.files[0];
    }
    else{
        this.uploadDoc[this.uploadDoc['dockey']] = null;
    }
  }

  public uploadDocFile() {
    let headers = new HttpHeaders();
    let options =  {headers: headers };
    // this.uploadDoc.user_id = this.user.id;
    
    let params = new FormData();
    for (let x in this.uploadDoc){
        if(x!="dockey"){
            params.append(x, this.uploadDoc[x]);
        }
    }
    
    this.http.post(gutil.devapiUrl + '/api/v1/documents/add?api_token=' + this.user.api_token, params, options)
      .subscribe((data:any) => {
        if(data.obj == 1){
          this.docUploadPass = true;
          this.docUploadFail = false;
          this.docUploadStatMsg = "Document submitted. Please wait for KYC verification.";
          document.getElementById('docPass').classList.add('slideup');
          document.getElementById('closeModal').click();
          setTimeout(() => {
            document.getElementById('docPass').classList.remove('slideup');
            document.getElementById('docPass').classList.add('slidedown');
          },5000);
          this.fetchDocumentInfo();
        }else{
          this.docUploadFail = true;
          this.docUploadPass = false;
          this.docUploadStatMsg = "Document not uploaded. Please try again or contact our sales team."
          document.getElementById('docFail').classList.add('slideup');
          document.getElementById('closeModal').click();
          setTimeout(() => {
            document.getElementById('docFail').classList.remove('slideup');
            document.getElementById('docFail').classList.add('slidedown');
            this.fetchDocumentInfo();
          },5000);
        }
      })
  } 

  public fetchTenantProp(){
    this.http.get(gutil.devapiUrl + '/api/v1/property/tenant/' + this.user.id + '/dashboard?api_token=' + this.user.api_token).subscribe((data:any) => {

    })
  }

}